// extracted by mini-css-extract-plugin
module.exports = {"flexbox":"styles_flexbox__2krnC","defaultSpacing":"styles_defaultSpacing__3LLpl","relativeBox":"styles_relativeBox__2mj3e","marginUnset":"styles_marginUnset__2JoL0"};